import styled from 'styled-components';
import {Link} from 'react-router-dom';

const StyledLink = styled(Link)`
    margin: 20px 0;
    text-align: center;
    font-size: 12px;
    padding: 17px 28px;
    color: #333;
    display: inline-block;
    vertical-align: top;
    border-radius: 2px;
    text-transform: uppercase;
    transition: background-color 0.3s ease-in-out, padding 0.3s ease-in-out;
    cursor: pointer;
    text-decoration: none;
    background: #dbbd68;
    text-decoration: none;

    &:hover {
        background: #d1ab3f;
    }
`;

const ErrorPage = styled.div`
    background: linear-gradient(to bottom, #666 0%, #383838 83%);
    width: 100%;
    height: 760px;
    position: relative;
    margin-top: 0;
    padding-bottom: 1em;
`;

const ErrorBox = styled.div`
    background: url(${p => p.errorBg || ''}) no-repeat;
    width: 520px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    top: 28%;
    padding: 50px 55px 50px 35px;

    div {
        position: relative;
        top: 2%;
        text-align: center;
    }
`;

const H1 = styled.h1`
    font-size: 100px;
    color: white;
    font-weight: bold;
    border-right: 3px solid white;
    display: inline-block;
    line-height: 70px;
    padding-right: 10px;
    margin: 0;
    margin-bottom: 20px;
    font-family: Brutal, Brutal_Medium, Arial, sans-serif;
    text-align: left;
`;

const H2 = styled.h2`
    margin-left: 10px;
    margin-bottom: 5px;
    margin-top: 20px;
    font-size: 27px;
    color: #fff;
    font-weight: bold;
    display: inline-block;
    line-height: 40px;
    word-wrap: break-word;
    text-transform: uppercase;
    font-family: Brutal, Brutal_Medium, Arial, sans-serif;
    text-align: left;
    font-weight: 700;
    text-align: left;
`;

const H3 = styled.h3`
    font-size: 20px;
    color: #828282;
    font-weight: bold;
    line-height: 1;
    margin: 0;
    margin-bottom: 5px;
    text-align: left;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
`;

const P = styled.p`
    color: #fff;
    font-family: Brutal, Brutal_Medium, Arial, sans-serif;
    font-size: 17px;
    margin: 0;
    padding: 0;
    text-align: left;
`;

export {ErrorPage, ErrorBox, H1, H2, H3, P, StyledLink};
